const Disconnect = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.75 2V0.5M10.25 14V15.5M2 5.75H0.5M14 10.25H15.5M2.68566 2.68566L1.625 1.625M13.3143 13.3143L14.375 14.375M8 12.2426L6.40901 13.8336C5.23744 15.0052 3.33794 15.0052 2.16637 13.8336C0.994796 12.6621 0.994796 10.7626 2.16637 9.59099L3.75736 8M12.2426 8L13.8336 6.40901C15.0052 5.23744 15.0052 3.33794 13.8336 2.16637C12.6621 0.994796 10.7626 0.994796 9.59099 2.16637L8 3.75736"
      stroke="#535862"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Disconnect;
